import type { TaskFailure } from '@camino-solutions/share/proto/common/services';

export class SessionTaskProcessingTaskFailureAction {
  static readonly type = '[Session] Task processing: TaskFailure';

  constructor(
    readonly cardId: string,
    readonly taskFailure: TaskFailure,
  ) {}
}
